<ng-container *ngIf="isDesktop else mobile">
  <app-desktop-main-client-area></app-desktop-main-client-area>
</ng-container>

<ng-template #mobile>
  <app-mobile-main-client-area></app-mobile-main-client-area>
</ng-template>
